/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ServiceAccountsTraitDTO } from './ServiceAccountsTraitDTO';
import {
    ServiceAccountsTraitDTOFromJSON,
    ServiceAccountsTraitDTOFromJSONTyped,
    ServiceAccountsTraitDTOToJSON,
} from './ServiceAccountsTraitDTO';
import type { ActiveProjectsTraitDTO } from './ActiveProjectsTraitDTO';
import {
    ActiveProjectsTraitDTOFromJSON,
    ActiveProjectsTraitDTOFromJSONTyped,
    ActiveProjectsTraitDTOToJSON,
} from './ActiveProjectsTraitDTO';
import type { DashboardsLimitsTraitDTO } from './DashboardsLimitsTraitDTO';
import {
    DashboardsLimitsTraitDTOFromJSON,
    DashboardsLimitsTraitDTOFromJSONTyped,
    DashboardsLimitsTraitDTOToJSON,
} from './DashboardsLimitsTraitDTO';
import type { TableViewsLimitsTraitDTO } from './TableViewsLimitsTraitDTO';
import {
    TableViewsLimitsTraitDTOFromJSON,
    TableViewsLimitsTraitDTOFromJSONTyped,
    TableViewsLimitsTraitDTOToJSON,
} from './TableViewsLimitsTraitDTO';
import type { ModelRegistryLimitsTraitDTO } from './ModelRegistryLimitsTraitDTO';
import {
    ModelRegistryLimitsTraitDTOFromJSON,
    ModelRegistryLimitsTraitDTOFromJSONTyped,
    ModelRegistryLimitsTraitDTOToJSON,
} from './ModelRegistryLimitsTraitDTO';
import type { OperationsLimitTraitDTO } from './OperationsLimitTraitDTO';
import {
    OperationsLimitTraitDTOFromJSON,
    OperationsLimitTraitDTOFromJSONTyped,
    OperationsLimitTraitDTOToJSON,
} from './OperationsLimitTraitDTO';
import type { PlanUpgradeTraitDTO } from './PlanUpgradeTraitDTO';
import {
    PlanUpgradeTraitDTOFromJSON,
    PlanUpgradeTraitDTOFromJSONTyped,
    PlanUpgradeTraitDTOToJSON,
} from './PlanUpgradeTraitDTO';
import type { ProjectVisibilityRestrictedTraitDTO } from './ProjectVisibilityRestrictedTraitDTO';
import {
    ProjectVisibilityRestrictedTraitDTOFromJSON,
    ProjectVisibilityRestrictedTraitDTOFromJSONTyped,
    ProjectVisibilityRestrictedTraitDTOToJSON,
} from './ProjectVisibilityRestrictedTraitDTO';

/**
 * 
 * @export
 * @interface OrganizationTraitsSetDTO
 */
export interface OrganizationTraitsSetDTO {
    /**
     * 
     * @type {ProjectVisibilityRestrictedTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    projectVisibilityRestricted?: ProjectVisibilityRestrictedTraitDTO;
    /**
     * 
     * @type {PlanUpgradeTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    planUpgrade?: PlanUpgradeTraitDTO;
    /**
     * 
     * @type {ServiceAccountsTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    serviceAccounts?: ServiceAccountsTraitDTO;
    /**
     * 
     * @type {OperationsLimitTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    operationLimit?: OperationsLimitTraitDTO;
    /**
     * 
     * @type {object}
     * @memberof OrganizationTraitsSetDTO
     */
    uiWorkspaceSwitching?: object;
    /**
     * 
     * @type {ActiveProjectsTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    activeProjects?: ActiveProjectsTraitDTO;
    /**
     * 
     * @type {DashboardsLimitsTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    dashboardsLimits?: DashboardsLimitsTraitDTO;
    /**
     * 
     * @type {TableViewsLimitsTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    tableViewsLimits?: TableViewsLimitsTraitDTO;
    /**
     * 
     * @type {ModelRegistryLimitsTraitDTO}
     * @memberof OrganizationTraitsSetDTO
     */
    modelRegistryLimits?: ModelRegistryLimitsTraitDTO;
}

/**
 * Check if a given object implements the OrganizationTraitsSetDTO interface.
 */
export function instanceOfOrganizationTraitsSetDTO(value: object): value is OrganizationTraitsSetDTO {
    return true;
}

export function OrganizationTraitsSetDTOFromJSON(json: any): OrganizationTraitsSetDTO {
    return OrganizationTraitsSetDTOFromJSONTyped(json, false);
}

export function OrganizationTraitsSetDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationTraitsSetDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'projectVisibilityRestricted': json['projectVisibilityRestricted'] == null ? undefined : ProjectVisibilityRestrictedTraitDTOFromJSON(json['projectVisibilityRestricted']),
        'planUpgrade': json['planUpgrade'] == null ? undefined : PlanUpgradeTraitDTOFromJSON(json['planUpgrade']),
        'serviceAccounts': json['serviceAccounts'] == null ? undefined : ServiceAccountsTraitDTOFromJSON(json['serviceAccounts']),
        'operationLimit': json['operationLimit'] == null ? undefined : OperationsLimitTraitDTOFromJSON(json['operationLimit']),
        'uiWorkspaceSwitching': json['uiWorkspaceSwitching'] == null ? undefined : json['uiWorkspaceSwitching'],
        'activeProjects': json['activeProjects'] == null ? undefined : ActiveProjectsTraitDTOFromJSON(json['activeProjects']),
        'dashboardsLimits': json['dashboardsLimits'] == null ? undefined : DashboardsLimitsTraitDTOFromJSON(json['dashboardsLimits']),
        'tableViewsLimits': json['tableViewsLimits'] == null ? undefined : TableViewsLimitsTraitDTOFromJSON(json['tableViewsLimits']),
        'modelRegistryLimits': json['modelRegistryLimits'] == null ? undefined : ModelRegistryLimitsTraitDTOFromJSON(json['modelRegistryLimits']),
    };
}

export function OrganizationTraitsSetDTOToJSON(value?: OrganizationTraitsSetDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectVisibilityRestricted': ProjectVisibilityRestrictedTraitDTOToJSON(value['projectVisibilityRestricted']),
        'planUpgrade': PlanUpgradeTraitDTOToJSON(value['planUpgrade']),
        'serviceAccounts': ServiceAccountsTraitDTOToJSON(value['serviceAccounts']),
        'operationLimit': OperationsLimitTraitDTOToJSON(value['operationLimit']),
        'uiWorkspaceSwitching': value['uiWorkspaceSwitching'],
        'activeProjects': ActiveProjectsTraitDTOToJSON(value['activeProjects']),
        'dashboardsLimits': DashboardsLimitsTraitDTOToJSON(value['dashboardsLimits']),
        'tableViewsLimits': TableViewsLimitsTraitDTOToJSON(value['tableViewsLimits']),
        'modelRegistryLimits': ModelRegistryLimitsTraitDTOToJSON(value['modelRegistryLimits']),
    };
}

